<template>
  <v-row v-if="!isInstructorMobile" >
    <v-row no-gutters class="white-bg pa-2 mt-4 border-radius-4">
      <v-col cols="12">
        <v-select 
          v-model="selectedWorkspaceActivities" 
          :items="workspaceActivities" 
          class="z5"
          label="Sélectionner les activités" 
          hide-details 
          dense 
          outlined
          multiple
          color="third"
          item-color="third"
          :menu-props="{ location: 'bottom', offsetY: true }"
          @change="changeWorkspaceActivities" 
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="white-bg px-2 mt-4 border-radius-4">
      <v-row v-for="(filter, index) in filters" v-if="filter.canShow" :key="`PlannerFilter_${index}`" no-gutters align="center">
        <v-col cols="10">
          <div class="full-height mr-2">
            <v-tooltip v-if="filter.tooltipText" bottom class="z5">
              <template #activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{ filter.text }}</span>
              </template>
              <span>{{ filter.tooltipText }}</span>
            </v-tooltip>
            <span v-else>{{ filter.text }}</span>
          </div>
        </v-col>
        <v-col cols="2">
          <v-switch v-model="filterValue[filter.value]" color="third" @change="filter.change" />
        </v-col>
      </v-row>
    </v-row>
  </v-row>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import store from '@/store';

export default {
  setup () {
    const monitorTypeValues = ['FORMATION', 'ADMINISTRATIF', 'ABSENCE', 'REUNION', 'PERMANENCE'];
    const isInstructorMobile = computed(() => store.getters.isIntructorOnMobile);
    const selectedWorkspaceActivities = ref([]);
    const workspaceActivities = computed(() => store.state.siteInfo?.pegaseSettings?.workspaceActivities);
    const currentTab = computed(() => store.state.currentTab);
    const canShowTreatmentSwitch = computed(() => currentTab.value === 'customer');
    const canShowMonitorTypeSessions = computed(() => currentTab.value !== 'instructor');
    const canShowPresentHorsesSwitch = computed(() => currentTab.value === 'horse');
    const filterValue = ref({
      showSessionOriginalColor: false,
      showTreatmentSessions: (store.state.showSessionsOfType || []).includes('SOINS'),
      showMonitorTypeSessions: false,
      synchronizePlanning: store.state.synchronizePlanning,
      presentHorses: store.state.horsesFilters?.active?.presentHorses ?? true
    });

    const changeWorkspaceActivities = () => {
      store.commit('setWorkspaceActivitiesFilter', selectedWorkspaceActivities.value);
    };

    const changeShowSessionOriginalColor = () => {
      store.commit('setShowOriginalSessionColor', filterValue.value.showSessionOriginalColor);
    };

    const changeShowTreatmentSession = () => {
      const types = store.state.showSessionsOfType;
      if (filterValue.value.showTreatmentSessions) {
        types.push('SOINS');
      } else {
        const index = types.findIndex(t => t === 'SOINS');
        if (index !== -1) {
          types.splice(index, 1);
        }
      }

      store.commit('setShowSessionsOfType', types);
    };

    const changeShowMonitorTypeSessions = () => {
      const sessionTypes = store.state.showSessionsOfType;

      if (filterValue.value.showMonitorTypeSessions) {
        sessionTypes.push(...monitorTypeValues);
      } else {
        monitorTypeValues.forEach(value => {
          const index = sessionTypes.findIndex(t => t === value);
          if (index !== -1) {
            sessionTypes.splice(index, 1);
          }
        });
      }

      store.commit('setShowSessionsOfType', sessionTypes);
    };

    const changeShowDisciplineColor = () => {
      store.commit('setShowDisciplineColor', filterValue.value.showDisciplineColor);
    };

    const changeSynchronizePlanning = () => {
      store.commit('setSynchronizePlanning', filterValue.value.synchronizePlanning);
    };

    const changePresentHorses = () => {
      store.commit('horsesFilters/setFilters', { key: 'presentHorses', value: filterValue.value.presentHorses });
    };

    const filters = computed(() => [
      { canShow: true, text: 'Désactiver les différences de couleur sur les sessions', value: 'showSessionOriginalColor', change: () => changeShowSessionOriginalColor() },
      { canShow: canShowTreatmentSwitch.value, text: 'Voir séances soins', value: 'showTreatmentSessions', change: () => changeShowTreatmentSession() },
      { canShow: canShowMonitorTypeSessions.value, text: 'Voir séances moniteurs', value: 'showMonitorTypeSessions', change: () => changeShowMonitorTypeSessions() },
      { canShow: true, text: 'Appliquer la couleur des disciplines', value: 'showDisciplineColor', change: () => changeShowDisciplineColor(), tooltipText: 'Uniquement pour les séances de type reprise' },
      { canShow: true, text: 'Synchroniser les plannings', value: 'synchronizePlanning', change: () => changeSynchronizePlanning() },
      { canShow: canShowPresentHorsesSwitch.value, text: 'Afficher uniquement les chevaux présents', value: 'presentHorses', change: () => changePresentHorses() }
    ]);

    return { filters, isInstructorMobile, filterValue, selectedWorkspaceActivities, workspaceActivities, changeWorkspaceActivities };
  }
};

</script>
